import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';


// import {
// 	statisticsAction,
// 	statisticsCloseAction
// } from '../../../actions/settingsAction.js';


import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';

import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';
import { useParams } from "react-router-dom";
const RoleAccessControl = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	const defaultChecked = false;

	const [selectedItems, setSelectedItems] = useState([]);
	const [isChecked, setIsChecked] = useState({ defaultChecked });


	const [checkbox, setCheckbox] = useState([]);

	const history = useHistory();
	const [data, setData] = useState([]);
	// const [leavedetaildata, setLeaveDetailData] = useState([]);
	


	const { search } = useLocation();
	const searchparams = new URLSearchParams(search);
	const param = searchparams.get("id");
	//const handleChange = (e) => setCheckbox(e.target.checked);

    const [leavedet, setLeaveDetail] = useState({
            status: "",
            remarks: "",
            leave_type_id:"",
            leave_id:"",
			emp_id:"",
            diff_days:"",
			available_leave:"",
            leave_available:"",
            sick_leave_available:"",

           
        })
	

        const handelInput = (event) => {
            event.preventDefault();
            const { name, value } = event.target;
            console.log(name, value)
            setLeaveDetail({ ...leavedet, [name]: value });
        }









	const handleEditLeaveStatus = (e) => {

		e.preventDefault();
		//console.log('selected options: '+ roledata.join(", "));
		// e.preventDefault();
		//console.log(param);

		
			const emp_id=leavedet.employee_id
            let available_leave_det;

			




		axios.post(API_BASE_URL + '/dept_overtime_update', { status: leavedet.status,remarks:leavedet.remarks, overtime_ids: param,overtime_hour:leavedet.overtime_hour,g:leavedet,fff:leavedet.from_date }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
  const status = response.data.status;

    if (status === 'success') {
      toast.success(response.data.message, {
        position: "bottom-right",
        autoClose: 5000,
        theme: "colored",
      });
      setTimeout(() => {
					return history.push("dept-ot");
				}, 3000);
    } else {
      toast.error(response.data.message, {
        position: "bottom-right",
        autoClose: 5000,
        theme: "colored",
      });
    }

		}).catch(error => {
            toast.error(error.response?.data?.message || "Update failed", {
              position: "bottom-right",
              autoClose: 5000,
              theme: "colored",
            });
          });







	 };


	useEffect(() => {
		axios.get(API_BASE_URL + '/floor_ot_detail/' + param, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})

		    // .then(res1 =>console.log(res1.data.leave_detail))
			.then(res1 => setLeaveDetail(res1.data.leave_detail))
			.catch(err => console.log(err));
	}, [])




	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />


						</div>
					</div>


					<div className="section-body mt-4">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-4 col-lg-6">
                                <div className="card">
                                    <div className="card-header">
                                        <h5 className="card-title">Overtime Detail</h5>
                                    </div>
                                    <div className="card-body">
                                      
                                        <div className="table-responsive">
                                            <table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
                                                    <tbody>
                                                        <tr>
                                                        <th>Employee</th>
                                                        <td>{leavedet.full_name}</td>
                                                        </tr>
                                                        <tr>
                                                        <th>Employee ID</th>
                                                        <td>{leavedet.emp}</td>
                                                        </tr>
                                                        <tr>
                                                        <th> Overtime Date</th>
                                                        <td>{leavedet.overtime_date}</td>
                                                        </tr>
                                                        <tr>
                                                        <th>Overtime Hour</th>
                                                        <td>{leavedet.ot_hours}</td>
                                                        </tr>
                                                        <tr>
  <th>Shift Time</th>
  <td>
    <strong>{leavedet.shift_name}</strong><br/>
    <small className="text-success">{leavedet.shift_time}</small>
  </td>
</tr>

<tr>
  <th>Punch In & Out</th>
  <td>{leavedet.punch_in} - {leavedet.punch_out}</td>
</tr>
                                                        <tr>
                                                        <th>Calculated Overtime Hour</th>
                                                        <td>{leavedet.overtime_hour}</td>
                                                        </tr>
														<tr>
														<th>Applied On</th>
                                                        <td>{leavedet.applied_on}</td>
                                                        </tr>
                                        {/* <tr>
														<th>Shift Hour</th>
                                                        <td>{leavedet.reason}</td>
                                                        </tr> */}
                                        
                                                    </tbody>
                                            </table>
                                        </div>



                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-5">
                                <form className="card" onSubmit={handleEditLeaveStatus}>
                                    <div className="card-body">
                                        <h3 className="card-title">Update Status</h3>
                                        <div className="row">
                                         
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Status <span style={{color:"red"}}>*</span></label>
                                                    <select className="form-control show-tick" name="status" value={leavedet.status} onChange={handelInput}>
                                                    <option value="" ></option>
                                                    <option value="1" >Pending</option>
                                                    <option value="2" >Approved</option>
                                                    <option value="3" >Rejected</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group mb-0">
                                                    <label className="form-label">Remarks</label>
                                                    <textarea rows={5} className="form-control required-input" id="textarea" name="remarks" value={leavedet.remarks}  onChange={handelInput} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    
                      

                                    <div className="card-footer text-left">

                                    <input type="hidden" name="overtime_id" value={leavedet.overtime_id} />
                                    <input type="hidden" name="emp_id" value={leavedet.employee_id} />
                                     <input type="hidden" name="overtime_hour" value={leavedet.overtime_hour} />

                                  

           
                                        <button type="submit" className="btn btn-primary">Save</button>
                                    </div>

                                    {/* {leavedet.status==1 && (

                                   
                                    )} */}
                                </form>
                           
                            </div>




                        </div>
                    </div>

                    </div>




				</div>
			</div>









		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(RoleAccessControl);